import { styled } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';

export const ImageContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  cursor: 'crosshair',
  transition: 'border-color 0.2s ease-in-out',
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  '&.dragging-over': {
    borderColor: theme.palette.primary.main,
    borderStyle: 'dashed',
  },
}));

export const PlacedElement = styled(Box)(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '24px',
  minHeight: '24px',
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontSize: '12px',
  fontWeight: 'bold',
  cursor: 'pointer',
  border: `2px solid ${theme.palette.common.white}`,
  boxShadow: theme.shadows[2],
  transition: 'all 0.2s ease-in-out',
  zIndex: 10,
  '&:hover': {
    transform: 'scale(1.1)',
    boxShadow: theme.shadows[4],
    zIndex: 11,
  },
  '&.dragging': {
    opacity: 0.5,
  },
}));

export const DraggableElement = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  margin: theme.spacing(0.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  cursor: 'grab',
  transition: 'all 0.2s ease-in-out',
  userSelect: 'none',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:active': {
    cursor: 'grabbing',
  },
  '&.dragging': {
    opacity: 0.5,
    transform: 'rotate(5deg)',
  },
}));

export const DropZone = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  pointerEvents: 'none',
  '&.active': {
    pointerEvents: 'auto',
    backgroundColor: 'rgba(25, 118, 210, 0.1)',
    border: `2px dashed ${theme.palette.primary.main}`,
  },
}));
